import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function load (component: string) {
  return () => import(`./pages/${component}`)
}

export default new Router({
  routes: [
    { path: '/', component: load('index') },
    { path: '/category', component: load('category') },
    { path: '/category/:category', component: load('category/_category'), props: true },
    { path: '/all', component: load('all') },
    { path: '/user-agent', redirect: '/all' },
    { path: '/user-agent/:agent', component: load('user-agent/_agent'), props: true },
    { path: '/random', component: load('random') },
    { path: '*', redirect: '/' }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router.ts